import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('insuredDevices');

export const getFiltered = (state, contractId) => getResources(state, device => device.contract === contractId);
export const get = (state, id) => state.resources[id];
export const getFilteredRequestStatus = (state) => {
  return state.requests && state.requests.getAll && state.requests.getAll.status;
}
export const getCreateError = (state) => state.requests.create && state.requests.create.error;
export const getActivationError = (state) => state.requests.update && state.requests.update.error;
export const getPurchase = (state, id) => state.meta[id] && state.meta[id].purchase;
